/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import helpers from '../base/helpers';
import template from './rating-row.stache';
import FeedDataService from 'scripts/services/rating-feed-service';
import * as React from "react";

Component.extend({
    tag: 'rating-row',
    template: template,
    viewModel: {
        element: null,
        define: {
            rating: {
                type: 'number',
                value: 0,
            },
            count: {
                type: 'number',
                value: 0,
            },
            pagePath: {
                type: 'string',
                value: '',
            },
            dataAvailable: {
                type: 'boolean',
                value: false,
            },
            showStars: {
                type: 'boolean',
                value: false,
            },
            showCount: {
                type: 'boolean',
                value: false,
            },
        },
        createStarClass(rating, currentValue) {
            let result = '';
            const diff = rating - currentValue;
            if (diff === -0.5) {
                result = ' clicked half ';
            } else if (currentValue <= rating) {
                result = ' clicked ';
            }

            return {className: 'star star-' + currentValue + result};
        },
        getStars() {
            const rating = Math.ceil(2 * this.attr('rating')) / 2;

            const stars = [1, 2, 3, 4, 5].map((item) => {
                return this.createStarClass(rating, item);
            });

            this.attr('stars', stars);
        },
        loadRating() {
            this.ratingLoader.loadRating(this.attr('pagePath'))
                .then((data) => {
                    if (!data) {
                        console.log('Empty response from rating url', data);
                        return;
                    }

                    let response = data;
                    if (typeof data === 'string') {
                        response = JSON.parse(data);
                    }

                    this.attr('rating', response.averageRating || 0);
                    this.attr('count', response.totalNumberOfRatings || 0);
                    this.attr('showStars', response.averageRating >= 3);
                    this.attr('showCount', response.totalNumberOfRatings >= 20);
                    this.getStars();
                });
        },
    },

    helpers,
    events: {
        inserted($el) {
            this.viewModel.attr('element', $el);
            this.viewModel.ratingLoader = new FeedDataService()
                .on('loading', (ev, data) => this.viewModel.attr('loading', data))
                .on('data', (data) => {

                })
                .on('error', (error) => {
                    console.log('Error', error);
                });

            this.viewModel.loadRating();
        }
    }
});
